import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '@core/config/config.service';
import { AuthService } from '@core/guards/auth.service';
import { HttpService } from '@core/http/http.service';
import { FaultedInvoiceModel } from '../models/invoices/faulted-invoice.model';

@Injectable({
  providedIn: 'root'
})
export class AdminService extends HttpService {

  constructor(protected http: HttpClient, protected config: ConfigService, protected authService: AuthService) {
    super(http, config, authService, 'admin');
  }

  getFaultedInvoices(): Observable<FaultedInvoiceModel[]> {
    return this.invokeGet<FaultedInvoiceModel[]>('faulted');
  }

  fixFaultedInvoices(invoicesId: string[]): Observable<any> {
    return this.invokePut(null, 'faulted', { invoiceId: invoicesId });
  }

  getAttachmentContent(ocrMetadataId: string): Observable<Blob> {
    return this.invokeGetFile(`${ocrMetadataId}/attachment`);
  }
}
